import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useNewUpdateCta } from '../../hooks/updates/updateCta';

export function NewUpdateCtaContainer(): JSX.Element | null {
	const {
		data: { canEdit, updateHref },
	} = useNewUpdateCta();

	if (!canEdit) return null;

	return (
		<div className="border-fill-accent-primary-weaker my-4 rounded-lg border bg-fill-accent-primary-weaker p-4">
			<div className="flex flex-row-reverse sm:flex-col md:flex-row-reverse md:items-center">
				<Text as="div" size="small" className="mb-0 sm:mb-2 md:mb-0">
					<Translate value="fe.components.updates_feed.post_description" />
				</Text>
				<div className="flex-1 p-2 sm:flex-none sm:p-0 md:p-2">
					<Button
						as="a"
						href={updateHref}
						variant="secondary-solid"
						size="small"
						className="w-full"
						data-qa="petition-updates-new-update-cta"
					>
						<Translate value="fe.components.updates_feed.post_button" />
					</Button>
				</div>
			</div>
		</div>
	);
}
